const modals = { email: "email", organization: "organization", wrongAddress: "wrongAddress" }; //TO DO REFACTOR WE DON'T NEED THIS
export default modals;
